'use client';

import { Button } from '@heroui/button';
import { Key } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { authClient } from '@/lib/auth-client';
import { useLoadingCallback } from '@/lib/hooks/use-loading-callback';
import { authToasts } from '@/lib/utils/toast';

export function PasskeyLoginButton() {
    const router = useRouter();

    const [handlePasskeyLogin, isLoading] = useLoadingCallback(async () => {
        try {
            const result = await authClient.signIn.passkey();
            if (result?.error) {
                authToasts.loginFailed('Passkey authentication failed');
            } else {
                authToasts.loginSuccess();
                router.push('/account/settings');
            }
        } catch {
            authToasts.loginFailed('An unexpected error occurred');
        }
    });

    return (
        <Button
            fullWidth
            isLoading={isLoading}
            onPress={handlePasskeyLogin}
            startContent={isLoading ? null : <Key className="h-4 w-4" />}
            variant="faded"
        >
            Use a passkey
        </Button>
    );
}
